import type { Source } from "../types";
import { appendAttribution, track } from "../session";

export function Sources({ sources }: { sources: Source[] }) {
  return (
    <div class="sources">
      {sources.map((s) => (
        <a
          key={s.url}
          class="source-chip"
          href={appendAttribution(s.url)}
          target="_blank"
          rel="noopener noreferrer"
          title={s.url}
          onClick={() => track("source_click", s.url, { title: s.title })}
        >
          <span class="source-chip-title">
            {s.title || hostnameFrom(s.url)}
          </span>
        </a>
      ))}
    </div>
  );
}

function hostnameFrom(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
